<div class="course-item" *ngIf="course$ | async as course">
    <div class="item">
        <table>
            <tr>
                <td class="id" *ngIf="course.courseId">{{ course.externalCourseNumber }}</td>
                <td *ngIf="course.title" colspan="7" class="title">
                    <a *ngIf="course.unicodeTitle && course.unicodeTitle !== null && course.unicodeTitle !== ''" class="title" a-link (click)="storeID()" [routerLink]="courseDetail">{{ course.unicodeTitle }}</a>
                    <a *ngIf="!course.unicodeTitle || course.unicodeTitle === null || course.unicodeTitle === ''" class="title" a-link (click)="storeID()" [routerLink]="courseDetail">{{ course.title }}</a>
                    <span *ngIf="course.isProduct" [innerHTML]="'courses.online' | translate"></span>
                    <span *ngIf="!course.isProduct && (course.productType === 'SEM' || course.productType === 'WRK')" [innerHTML]="'courses.presence' | translate"></span>
                    <span *ngIf="!course.isProduct && course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></span>
                </td>
                <td class="last links">
                    <a da-link [routerLink]="bookingDetails"
                        ><span class="drg-icon-arrow_right"></span><span [innerHTML]="translationPrefix + '.myBooking' | translate"></span
                    ></a>
                </td>
            </tr>
            <tr class="details">
                <td *ngIf="course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" class="is-infopackage" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <strong [innerHTML]="(translationPrefix + '.status' | translate) + ' '"></strong>
                        <ng-container *ngIf="course.status">
                            <span *ngIf="currentStatus">{{ currentStatus }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.status">-</span>
                    </div>
                </td>
                <td *ngIf="!course.infoPackageAvailable || !(subModulesAvailable$ | async)"></td>
                <td *ngIf="!course.infoPackageAvailable || !(subModulesAvailable$ | async)" class="date" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <span *ngIf="course.startDate"
                            ><span [innerHTML]="translationPrefix + '.availableFrom' | translate"></span>
                            <span *ngIf="course.startDate">{{ course.startDate | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}</span></span
                        >
                        <span *ngIf="course.endDate"
                            ><span [innerHTML]="translationPrefix + '.availableTo' | translate"></span>
                            <span *ngIf="course.endDate">{{ course.endDate | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}</span>
                        </span>
                    </div>
                    <div class="city" *ngIf="course.location && course.location.city">
                        <a (click)="openOverlay(course)">{{ course.location.city }}</a>
                    </div>
                </td>
                <td *ngIf="course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" class="date" [ngClass]="course.startDate || (course.location && course.location.city) ? '' : 'mobile'">
                    <div>
                        <strong [innerHTML]="(translationPrefix + '.result' | translate) + ' '"></strong>
                        <ng-container>
                            <span *ngIf="testResult$ | async">{{ testResult$ | async }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.testResult && !course.isProduct">-</span>
                    </div>
                </td>
                <td colspan="6" class="results">
                    <div *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.status' | translate"></strong>
                        <ng-container *ngIf="course.status">
                            <span *ngIf="currentStatus">{{ currentStatus }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.status">-</span>
                    </div>
                    <div  *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.result' | translate"></strong>
                        <ng-container>
                            <span *ngIf="testResult$ | async">{{ testResult$ | async }}</span>
                        </ng-container>

                        <span class="line" *ngIf="!course.testResult && !course.isProduct">-</span>
                    </div>
                    <div *ngIf="!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async)">
                        <strong [innerHTML]="translationPrefix + '.certificate' | translate"></strong>
                        <span *ngIf="course.certificateUrl"
                            ><a
                                da-link
                                [href]="course.certificateUrl"
                                [innerHTML]="(downloadLabel$ | async)"
                            ></a
                        ></span>
                        <span class="line" *ngIf="!course.certificateUrl">-</span>
                    </div>
                </td>
                <td class="last buttons">
                    <a
                        *ngIf="course.startPage && (!course.infoPackageAvailable || course.infoPackageSubModuleIds.length === 0 || !(subModulesAvailable$ | async))"
                        [href]="course.startPage"
                        target="_blank"
                        class="button primary"
                        [innerHTML]="translationPrefix + '.startCourse' | translate"
                    ></a>
                </td>
            </tr>
        </table>
        <da-info-package *ngIf="loggedIn && course.infoPackageAvailable && course.infoPackageSubModuleIds.length > 0 && (subModulesAvailable$ | async) && course.status === 'BOOKED'" [course]="course" [mycourses]="mycourses"></da-info-package>
    </div>
</div>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup" *ngIf="location$ | async as course">
        <div class="title">
            <span [innerHTML]="'common.location' | translate"></span>
        </div>
        <div class="details">
            <span><strong [innerHTML]="'common.address' | translate"></strong></span>
            <span>{{ course.location.name }}</span>
            <span>{{ course.location.street }}</span>
            <span>{{ course.location.city }} {{ course.location.zip }} </span>
            <span>{{ course.location.regionKey }}</span>
            <span>{{ countryName }} ({{ course.location.countryKey }})</span>
            <div><a class="button primary" [innerHTML]="'common.close' | translate" (click)="closeModal()"></a></div>
        </div>
    </div>
</ng-template>

<ng-template #modal>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="edit"></ng-container>
    </div>
</ng-template>
<ng-template #edit>
    <div>
        <div class="title">
            <h2 [innerHTML]="translationPrefix + '.titleEdit' | translate">Location</h2>
        </div>
        <div class="details" [innerHTML]="translationPrefix + '.textEdit' | translate">Lorem ipsum</div>
    </div>
</ng-template>
